import React from 'react';
import { FormattedMessage } from 'react-intl';

import Sidebar from 'carbon-react/lib/components/sidebar';
import Typography from 'carbon-react/lib/components/typography';

import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { WorkspaceSettingsContextProvider } from './context/workspace-settings-context';
import { WorkspaceSettingsContainer } from './containers/workspace-settings-container';

interface WorkspaceSettingsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  workspaceId?: string;
}

export const WorkspaceSettingsSidebar = ({ isOpen, onClose, workspaceId }: WorkspaceSettingsSidebarProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  return (
    <Sidebar
      header={
        <Typography variant="h2" fontWeight="700">
          <FormattedMessage id="workspaces.workspace_settings" defaultMessage="Workspace settings" />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
    >
      {workspaceId && (
        <WorkspaceSettingsContextProvider key={resetKey} workspaceId={workspaceId}>
          <WorkspaceSettingsContainer onClose={onClose} />
        </WorkspaceSettingsContextProvider>
      )}
    </Sidebar>
  );
};
